import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { formattedDate3 } from '../../../../helper/utils/formattedDate';
import { isEmptyObject } from '../../../../helper/utils/isEmptyObject';
import FloatingCheckoutButton from '../../components/FloatingCheckoutButton';
import ProductList from '../../components/ProductList';
import ProductsOverview from '../../components/ProductsOverview';
import useOnlineSales from '../../hooks/useOnlineSales';
import usePages from '../../hooks/usePages';
import HeroSection from './components/Hero';

export default function ProductsPage() {
    const navigate = useNavigate();

    const { groupedData, loading, loadingOrder, selectedDate, handleGetProductAvailability } = useOnlineSales();
    const { page } = usePages();

    const { productId } = useParams();
    const [product, setProduct] = useState({});

    useEffect(() => {
        if (productId && !isEmptyObject(page)) {
            const productPage = page?.['products'] || {};
            const allProducts = productPage?.['items'] || [];
            const findProduct = allProducts.find((product) => (product?.['id'] || '').toString().trim().toLowerCase() === productId.toString().trim().toLowerCase()) || {};

            if (isEmptyObject(findProduct)) {
                navigate('/');
                return;
            }

            setProduct(findProduct);
            localStorage.setItem('product', JSON.stringify(findProduct));
        }
    }, [productId, page]);

    return (
        <>
            <HeroSection hero={product['detail'] || {}} />
            {!isEmptyObject(product) && (
                <ProductsOverview
                    products={groupedData}
                    overview={page['sales'] || {}}
                    type={product['id']}
                    isLoading={loadingOrder || loading}
                    onGetProducts={() => {
                        if (selectedDate) {
                            handleGetProductAvailability(product['id'], formattedDate3(selectedDate));
                        }
                    }}
                />
            )}
            <FloatingCheckoutButton />
            {!isEmptyObject(product) && <ProductList product={page['products'] || {}} />}
        </>
    );
}
